<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h2 class="headline">Analytics Dashboard</h2>
            <v-spacer></v-spacer>
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Date Range"
                  prepend-icon="fa-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateRange"
                range
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="dateMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="applyDateRange">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 md8>
        <transaction-chart
          :date-range="selectedDateRange"
          height="400px"
          @drill-down="handleTransactionDrillDown"
        />
      </v-flex>

      <v-flex xs12 md4>
        <payment-method-chart
          height="400px"
          @drill-down="handlePaymentMethodDrillDown"
        />
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-title>
            Funding Period
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="fundingPeriod" mandatory>
              <v-btn flat value="daily">Daily</v-btn>
              <v-btn flat value="weekly">Weekly</v-btn>
              <v-btn flat value="monthly">Monthly</v-btn>
            </v-btn-toggle>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <funding-chart
          :period="fundingPeriod"
          height="400px"
          @drill-down="handleFundingDrillDown"
        />
      </v-flex>

      <v-flex xs12 md6>
        <v-card>
          <v-card-title class="headline">Key Metrics</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <div class="text-xs-center">
                  <div class="display-1 primary--text">{{ totalTransactions }}</div>
                  <div class="subheading">Total Transactions</div>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="text-xs-center">
                  <div class="display-1 success--text">${{ totalRevenue }}</div>
                  <div class="subheading">Total Revenue</div>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="text-xs-center">
                  <div class="display-1 accent--text">${{ averageTransaction }}</div>
                  <div class="subheading">Avg Transaction</div>
                </div>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="text-xs-center">
                  <div class="display-1 info--text">{{ successRate }}%</div>
                  <div class="subheading">Success Rate</div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card>
          <v-card-title class="headline">Quick Actions</v-card-title>
          <v-card-text>
            <v-btn block color="primary" @click="exportDashboard">
              <v-icon left>fa-download</v-icon>
              Export Dashboard
            </v-btn>
            <v-btn block color="accent" class="mt-2" @click="refreshData">
              <v-icon left>fa-refresh</v-icon>
              Refresh Data
            </v-btn>
            <v-btn block class="mt-2" @click="$router.push('/transactions')">
              <v-icon left>fa-list</v-icon>
              View All Transactions
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TransactionChart from './TransactionChart.vue'
import FundingChart from './FundingChart.vue'
import PaymentMethodChart from './PaymentMethodChart.vue'
import ApiMixin from '@/mixins/api'

export default {
  name: 'AnalyticsDashboard',
  components: {
    TransactionChart,
    FundingChart,
    PaymentMethodChart
  },
  mixins: [ApiMixin],
  data () {
    return {
      dateMenu: false,
      dateRange: [],
      selectedDateRange: {
        start: null,
        end: null
      },
      fundingPeriod: 'weekly',
      totalTransactions: '2,547',
      totalRevenue: '385,290',
      averageTransaction: '151.23',
      successRate: '94.2'
    }
  },
  computed: {
    dateRangeText () {
      if (this.dateRange.length === 2) {
        return `${this.dateRange[0]} to ${this.dateRange[1]}`
      } else if (this.dateRange.length === 1) {
        return this.dateRange[0]
      }
      return 'Select date range'
    }
  },
  methods: {
    applyDateRange () {
      if (this.dateRange.length === 2) {
        this.selectedDateRange = {
          start: this.dateRange[0],
          end: this.dateRange[1]
        }
      }
      this.dateMenu = false
    },
    handleTransactionDrillDown (data) {
      console.log('Transaction drill-down:', data)
    },
    handleFundingDrillDown (data) {
      console.log('Funding drill-down:', data)
    },
    handlePaymentMethodDrillDown (data) {
      console.log('Payment method drill-down:', data)
    },
    exportDashboard () {
      this.$store.commit('info', 'Dashboard export functionality will trigger chart exports')
    },
    refreshData () {
      this.$store.commit('info', 'Refreshing dashboard data...')
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.headline {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/AnalyticsDashboard.vue